























































































































































































































































































































import {
  API_EXPORT_TASK_SYNC,
  API_BILL_FILTER_OPTIONS,
  API_BILL_LIST,
  API_BILL_SIMPLE_STATIS,
} from "@/configs/Apis";
import { MSG_EXPORT_FILE_NOTFOUND } from "@/configs/Consts";
import formatters from "@/utils/ColumnFormater";
import {
  hasPermission,
  isEmpty,
  isEmptyOrWhiteSpace,
  mergeColumns,
  showConfirm,
  showError,
  showSuccess,
  showWarning,
} from "@/utils/Common";
import { Fetcher as Ajax } from "@/utils/Request";
import moment, { Moment } from "moment";
import BillForm from "@/views/bill/subviews/BillForm.vue";
import BillStatis from "@/views/bill/subviews/BillStatis.vue";
import { TableColumn } from "element-ui/types/table-column";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {
    BillForm,
    BillStatis,
  },
})
export default class BillIndex extends Vue {
  nodeQueryData = "";
  queryData: any = {
    billDateOption: "all",
    revenueCategoryId: "",
    expenseCategoryId: "",
    buildingId: "",
    remployeeId: "",
  };

  addBillFormDialogVisible = false;
  billItem: any = { id: 0 };

  billStatisDialogVisible = false;

  hasSelectedItems = false;

  queryStr = "";
  loadData = false;

  showSearch = false;

  filterOptions = {
    revenueCategoryList: [],
    expenseCategoryList: [],
    buildingList: [],
    employeeList: [],
  };

  statis = {
    monthStatis: {
      revenue: 0,
      expense: 0,
      profit: 0,
    },
    totalStatis: {
      revenue: 0,
      expense: 0,
      profit: 0,
    },
  };

  loadSimpleStatis() {
    Ajax.queryData(API_BILL_SIMPLE_STATIS, {}, "GET")
      .then((rs: any) => {
        this.statis = rs || {
          monthStatis: {
            revenue: 0,
            expense: 0,
            profit: 0,
          },
          totalStatis: {
            revenue: 0,
            expense: 0,
            profit: 0,
          },
        };
      })
      .catch(() => {
        this.statis = {
          monthStatis: {
            revenue: 0,
            expense: 0,
            profit: 0,
          },
          totalStatis: {
            revenue: 0,
            expense: 0,
            profit: 0,
          },
        };
      });
  }

  mounted() {
    Ajax.queryData(API_BILL_FILTER_OPTIONS, {}, "GET")
      .then((rs: any) => {
        this.filterOptions = rs || {
          revenueCategoryList: [],
          expenseCategoryList: [],
          buildingList: [],
          employeeList: [],
        };
      })
      .catch(() => {
        this.filterOptions = {
          revenueCategoryList: [],
          expenseCategoryList: [],
          buildingList: [],
          employeeList: [],
        };
      });

    this.loadSimpleStatis();
  }

  showStatis() {
    this.billStatisDialogVisible = true;
  }

  hasPerm(checkedPerm: string) {
    return hasPermission(this.$store.getters["user/user"] || {}, checkedPerm);
  }

  get treeData() {
    const module = this.$store.state.bill;
    if (!module) {
      return null;
    }
    return module.billTree;
  }

  onTreeNodeClick(index: string) {
    if (isEmptyOrWhiteSpace(index)) {
      return;
    }
    const parts = index.split("-");
    let nodeData: any = null;
    if (parts.length === 1) {
      nodeData = this.treeData[parts[0]];
    } else {
      nodeData = this.treeData[parts[0]].children[parts[1]];
    }
    if (!nodeData) {
      return;
    }
    this.nodeQueryData = JSON.stringify(nodeData.billFilter || {});
    // this.onQueryChanged();
  }

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_BILL_LIST;
  }

  get colFormatters() {
    return formatters;
  }

  createTableColumns() {
    const defaultColumns: Array<TableColumnOption> = [
      { prop: "billDate", display: "账单日期", width: 110 },
      // { prop: "revenueCategoryId", display: "收入分类", width: 120 },
      // { prop: "expenseCategoryId", display: "支出分类", width: 120 },
      { prop: "amount", display: "金额", width: 240 },
      { prop: "payType", display: "支付方式", width: 110 },
      { prop: "buildingId", display: "房屋", width: 110 },
      { prop: "employeeId", display: "员工", width: 110 },
      { prop: "createdUserId", display: "创建人", width: 110 },
      { prop: "modifiedUserId", display: "修改人", width: 110 },
      { prop: "remark", display: "备注" },
    ];
    this.$store
      .dispatch("bill/getListLayout", { listName: "BILL" })
      .then((layout) => {
        const columns = mergeColumns(
          JSON.parse(layout || "[]"),
          defaultColumns
        );
        this.applyColumnFormatters(columns);
        return columns;
      })
      .then((columns) => this.$store.dispatch("bill/setColumns", columns));
  }

  applyColumnFormatters(columns: Array<TableColumnOption>) {
    const fmers = {
      amount: this.colFormatters.formatAmount.bind(this),
      revenueCategoryId:
        this.colFormatters.formatBillRevenueCategory.bind(this),
      expenseCategoryId:
        this.colFormatters.formatBillExpenseCategory.bind(this),
      buildingId: this.colFormatters.formatBillBuilding.bind(this),
      employeeId: this.colFormatters.formatBillEmployee.bind(this),
      createdUserId: this.colFormatters.formatBillCreatedUser.bind(this),
      modifiedUserId: this.colFormatters.formatBillModifiedUser.bind(this),
      payType: this.colFormatters.formatBillPayType.bind(this),
    };
    if (!columns || !columns.length) {
      return;
    }
    columns.forEach((option) => {
      if (!Object.prototype.hasOwnProperty.call(fmers, option.prop)) {
        return;
      }
      option.formatter = (fmers as any)[option.prop];
    });
  }

  reloadTreeAndData() {
    this.loadBillTree();
    this.searchData();
    this.loadSimpleStatis();
  }

  onModuleRegistered() {
    this.$nextTick()
      .then(() => this.createTableColumns())
      .then(() => {
        this.loadBillTree();
        this.onSearchConditionChange();
        this.loadSimpleStatis();
      });
  }

  loadBillTree() {
    return this.$store.dispatch("bill/getBillTree");
  }

  onTextKeyup() {
    ((this.$refs.searchBtn as Vue).$el as HTMLInputElement).focus();
  }

  onBillDateChange(arrs: Array<string>) {
    if (arrs && arrs.length) {
      this.queryData.startDate = arrs[0];
      this.queryData.endDate = arrs[1];
    } else {
      (this.queryData.startDate as any) = undefined;
      (this.queryData.endDate as any) = undefined;
    }
    this.onSearchConditionChange();
  }

  @Watch("queryData.revenueCategoryId")
  @Watch("queryData.expenseCategoryId")
  @Watch("queryData.buildingId")
  @Watch("queryData.employeeId")
  onSearchConditionChange() {
    const params: { [key: string]: any } = {};
    if (!isEmptyOrWhiteSpace(this.nodeQueryData)) {
      const nodeFilter = JSON.parse(this.nodeQueryData);
      Object.keys(nodeFilter).forEach(
        (name) => (params[name] = nodeFilter[name])
      );
    }
    if (this.queryData.revenueCategoryId) {
      params.revenueCategoryId = this.queryData.revenueCategoryId;
    }
    if (this.queryData.expenseCategoryId) {
      params.expenseCategoryId = this.queryData.expenseCategoryId;
    }
    if (this.queryData.buildingId) {
      params.buildingId = this.queryData.buildingId;
    }
    if (this.queryData.employeeId) {
      params.employeeId = this.queryData.employeeId;
    }
    if (!isEmptyOrWhiteSpace(this.queryData.startDate)) {
      params.startDate = this.queryData.startDate;
    }
    if (!isEmptyOrWhiteSpace(this.queryData.endDate)) {
      params.endDate = this.queryData.endDate;
    }
    const paramsStr = JSON.stringify(params);
    if (paramsStr === "{}" && this.queryStr.trim() === "") {
      this.queryStr = "{}";
    } else if (paramsStr !== this.queryStr.trim()) {
      this.queryStr = JSON.stringify(params);
    }
  }

  @Watch("queryData.billDateOption")
  onBillDateOptionChange() {
    let now: Moment | null = moment();
    let startDate: Moment | null = moment();
    switch (this.queryData.billDateOption) {
      case "oneweek":
        startDate = startDate.add(-7, "days");
        break;
      case "onemonth":
        startDate = startDate.add(-1, "months");
        break;
      case "threemonth":
        startDate = startDate.add(-3, "months");
        break;
      default:
        now = null;
        startDate = null;
        break;
    }
    if (!isEmpty(now)) {
      this.queryData.endDate = now!.format("YYYY-MM-DD");
    } else {
      (this.queryData.endDate as any) = undefined;
    }
    if (!isEmpty(startDate)) {
      this.queryData.startDate = startDate!.format("YYYY-MM-DD");
    } else {
      (this.queryData.startDate as any) = undefined;
    }
    if (this.queryData.billDateOption !== "custom") {
      this.onSearchConditionChange();
    }
    if (
      this.queryData.billDateOption !== "custom" &&
      Reflect.has(this.queryData, "billDate")
    ) {
      this.queryData.billDate = null;
    }
  }

  @Watch("nodeQueryData")
  onNodeQueryDataChange() {
    this.queryData = { code: "" };
    this.onSearchConditionChange();
  }

  searchData() {
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  addRevenueBill() {
    this.billItem = {
      id: 0,
      amount: 0.0,
      billDate: moment().format("YYYY-MM-DD"),
      revenueCategoryId:
        this.filterOptions.revenueCategoryList.length > 0
          ? (this.filterOptions.revenueCategoryList[0] as any).id
          : -1,
    };
    this.addBillFormDialogVisible = true;
  }

  addExpenseBill() {
    this.billItem = {
      id: 0,
      amount: 0.0,
      billDate: moment().format("YYYY-MM-DD"),
      expenseCategoryId:
        this.filterOptions.expenseCategoryList.length > 0
          ? (this.filterOptions.expenseCategoryList[0] as any).id
          : -1,
    };
    this.addBillFormDialogVisible = true;
  }

  addBillSuccess() {
    this.addBillFormDialogVisible = false;
    this.reloadTreeAndData();
    this.billItem = { id: 0 };
  }

  editBill() {
    const selectedRows = (this.$refs.billgrid as any).getSelectedDataRows();
    if (!selectedRows || selectedRows.length === 0) {
      showWarning("请选择一条数据");
      return;
    }
    this.billItem = JSON.parse(JSON.stringify(selectedRows[0]));
    this.addBillFormDialogVisible = true;
  }

  exportData(cmd: string) {
    let dataFilter: any = {};
    if (cmd === "selected") {
      const selectedRows = (this.$refs.billgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      dataFilter.selectedIds = selectedRows;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        dataFilter = JSON.parse(this.queryStr);
      }
    }
    const fieldParams: Array<any> = ((this.$refs.billgrid as any).columns || [])
      .filter((column: any) => !column.hidden)
      .map((column: any) => {
        return {
          field: column.prop,
          label: column.display,
          width: column.width || 30,
        };
      });
    const params: any = {
      dataType: "Bill",
      fieldParams: JSON.stringify(fieldParams),
      dataFilter: JSON.stringify(dataFilter),
    };
    Ajax.queryData(API_EXPORT_TASK_SYNC, params)
      .then((task: any) => {
        const url = task.resultUrl || "";
        if (isEmpty(url)) {
          showWarning(MSG_EXPORT_FILE_NOTFOUND);
          return;
        }
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        if (a.parentNode) {
          a.parentNode.removeChild(a);
        }
      })
      .catch(({ message }) => showError(message));
  }

  onSelectionChanged(selectedRows: any[]) {
    this.hasSelectedItems = selectedRows.length > 0;
  }

  onRowClick(command: string, data: any, event: MouseEvent) {}

  onColumnConfiged({
    data = [],
    hidden = [],
  }: {
    data: Array<TableColumnOption>;
    hidden: Array<TableColumnOption>;
  }) {
    const newData: Array<TableColumnOption> = JSON.parse(JSON.stringify(data));
    const newHidden: Array<TableColumnOption> = JSON.parse(
      JSON.stringify(hidden)
    );
    // 删除属性
    newData.forEach((item) => delete item.hidden);
    if (hidden && hidden.length) {
      newData.push(
        ...newHidden.map((val) => Object.assign(val, { hidden: true }))
      );
    }
    this.$store
      .dispatch("bill/saveListLayout", {
        listName: "USER",
        layout: JSON.stringify(newData),
      })
      .then(() => this.$store.dispatch("bill/setColumns", []))
      .then(() => this.createTableColumns())
      .catch(({ message }) => showError(message));
  }

  onColumnResize(newWidth: number, column: TableColumn) {
    this.$store.dispatch("bill/setColumnWidth", {
      listName: "bill",
      column: column.property,
      newWidth,
    });
  }

  openColumnConfig() {
    const grid = this.$refs.billgrid as any;
    grid.openColumnConfig();
  }

  onTableDataLoaded() {
    //
  }

  openSearchPanel() {
    this.showSearch = !this.showSearch;
  }

  batchDeleteData(cmd: string) {
    let params: any = {};
    let msg = "当前列表";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.billgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      params.selectedIds = selectedRows;
      msg = `${selectedRows.length} 条数据`;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    showConfirm(`是否确认删除 ${msg}？`).then(() => {
      this.$store
        .dispatch("bill/deleteBill", params)
        .then(() => {
          showSuccess("删除成功");
          this.reloadTreeAndData();
        })
        .catch(({ message }) => showError(message));
    });
  }
}
